import React, { useState, useEffect } from 'react';
import {
  faBarsProgress,
  faArrowProgress,
  faScrewdriverWrench,
} from '@fortawesome/pro-solid-svg-icons';
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';
import PageHeader from '../pagecomponents/PageHeader';
import profilingScreenshot from '../pagecomponents/screenshots/manager/2. EmployeeCard.png';
import placeholderComponent from '../pagecomponents/screenshots/placeholdercomponent.png';

// Nuevas imágenes para las secciones
import realProgress from '../pagecomponents/screenshots/development/realprogress.png';
import betherPlanImg from '../pagecomponents/screenshots/development/betherplan.png';
import betherTool from '../pagecomponents/screenshots/development/bethertool.png';

import SectionBodyLeft from '../pagecomponents/SectionBodyLeft';
import SectionBodyRight from '../pagecomponents/SectionBodyRight';
import EconomicImpactStats from '../pagecomponents/EconomicImpactStats';
import FAQ from '../pagecomponents/FAQ';

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  mainSection: {
    flex: 1,
    backgroundColor: '#f9f9f9',
  },
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '20px',
    padding: '40px 20px',
    backgroundColor: '#fff',
  },
};

const content = {
  es: {
    hero: {
      title: 'Desarrolla a tu Talento de forma personalizada',
      intro:
        'Convierte la formación en una experiencia personalizada y verdaderamente útil. Olvídate de los cursos genéricos donde sólo el 20 % aporta valor. Da la bienvenida al aprendizaje enfocado y a los cambios reales en cada empleado.',
      cta: 'Reservar Demo',
    },
    sections: [
      {
        title: 'Convierte el potencial en progreso real',
        texts: [
          'Crea planes de desarrollo personalizados junto a cada miembro del equipo.',
          'Define metas claras y alcanzables. Consigue avances reales y permanentes',
          'Nuestra IA analiza tus evaluaciones y propone un BetherPlan® personalizado.',
        ],
      },
      {
        title: 'BetherPlan® al instante',
        texts: [
          'Diagnóstico profundo con IA para identificar áreas de impacto.',
          'Hitos semanales y mensuales para seguimiento medible.',
          'Alertas de seguimiento, para poner atención en lo importante',
        ],
      },
      {
        title: 'BetherTools®: acciones diarias que generan cambio',
        texts: [
          'Microtareas diarias para reforzar habilidades clave.',
          'Recordatorios inteligentes para mantener el foco.',
          'Recursos just-in-time: videos y articulos donde y cuando los necesites.',
        ],
      },
    ],
  },
  en: {
    hero: {
      title: 'Develop Your Talent in a Personalized Way',
      intro:
        'Transform training into a personalized, truly valuable experience. Say goodbye to generic courses where only 20% delivers value. Welcome focused learning and real change for every employee.',
      cta: 'Book a Demo',
    },
    sections: [
      {
        title: 'Turn Potential into Real Progress',
        texts: [
          'Create personalized development plans with each team member.',
          'Set clear, achievable goals and achieve real, lasting progress.',
          'Our AI analyzes your assessments and proposes a personalized BetherPlan®.',
        ],
      },
      {
        title: 'BetherPlan® Instantly',
        texts: [
          'In-depth AI-driven diagnosis to identify high-impact areas.',
          'Weekly and monthly milestones for measurable tracking.',
          'Follow-up alerts to keep attention on what matters most.',
        ],
      },
      {
        title: 'BetherTools®: Daily Actions That Drive Change',
        texts: [
          'Daily micro-tasks to reinforce key skills.',
          'Smart reminders to maintain focus.',
          'Just-in-time resources: videos and articles whenever and wherever you need them.',
        ],
      },
    ],
  },
};

export default function DevelopPage() {
  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'es'
  );

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const lang = content[language] || content.es;

  const handleDemoClick = () => console.log('Reservar Demo clicked');

  const icons = [faBarsProgress, faArrowProgress, faScrewdriverWrench];

  // Array de imágenes por sección
  const sectionImages = [realProgress, betherPlanImg, betherTool];

  // Construcción de las secciones con sus imágenes
  const sections = lang.sections.map((sec, idx) => ({
    icon: icons[idx],
    title: sec.title,
    imageSrc: sectionImages[idx] || placeholderComponent,
    texts: sec.texts,
  }));

  const impactStats = [
    {
      number: '+65',
      desc:
        language === 'es' ? 'Días hasta estar operativo' : 'Days to Readiness',
    },
    {
      number: '25%',
      desc:
        language === 'es'
          ? 'Empleados que valoran positivamente los 1:1 con sus líderes'
          : 'Employees who rate 1:1s with their leaders positively',
    },
    {
      number: '48.3%',
      desc:
        language === 'es'
          ? 'Empleados que valoran positivamente su plan de desarrollo'
          : 'Employees who rate their development plan positively',
    },
  ];

  const faqs = {
    es: [
      {
        question: '¿Qué incluye un BetherPlan®?',
        answer:
          'Con base en un bloqueador de carrera detectado por IA, BetherPlan transforma esa oportunidad de crecimiento en una serie de objetivos pequeños (BetherTools) que te harán avanzar para solucionar ese bloqueo, con hitos semanales y mensuales.',
      },
      {
        question: '¿Cómo se personalizan los objetivos para cada empleado?',
        answer:
          'Nuestra IA analiza tus evaluaciones y los bloqueadores de carrera para definir metas específicas, alcanzables y relevantes.',
      },
      {
        question: '¿Cómo funcionan las BetherTools® en el desarrollo diario?',
        answer:
          'Las BetherTools® te ofrecen microtareas diarias, alertas de seguimiento y recursos just-in-time (vídeos y artículos) que te permiten cambiar pequeños hábitos, los cuales se transforman en rutinas permanentes.',
      },
      {
        question:
          '¿Cómo puedo hacer seguimiento y medir el progreso de mi equipo?',
        answer:
          'A través de gráficos dinámicos compartidos entre mánager y colaborador, con hitos y métricas cuantificables para monitorizar avances. Además, con las alertas te aseguras de que ninguna oportunidad se pierda en una matriz de datos interminable.',
      },
    ],
    en: [
      {
        question: 'What does a BetherPlan® include?',
        answer:
          'Based on an AI-detected career blocker, BetherPlan turns that growth opportunity into a series of small goals (BetherTools) that move you toward resolving the blocker, with weekly and monthly milestones.',
      },
      {
        question: 'How are goals personalized for each employee?',
        answer:
          'Our AI analyzes your assessments and career blockers to set specific, attainable, and relevant goals.',
      },
      {
        question: 'How do BetherTools® work in day-to-day development?',
        answer:
          'BetherTools® provide daily micro-tasks, follow-up alerts, and just-in-time resources (videos and articles) that help you change small habits, which then become permanent routines.',
      },
      {
        question: 'How can I track and measure my team’s progress?',
        answer:
          'Through dynamic charts shared between manager and employee, with milestones and quantifiable metrics to monitor progress. Alerts also ensure that no opportunity is lost in an endless data matrix.',
      },
    ],
  };

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />

      <PageHeader
        title={lang.hero.title}
        subtitle={lang.hero.intro}
        ctaText={lang.hero.cta}
        onCtaClick={handleDemoClick}
        imageSrc={profilingScreenshot}
      />

      <main style={styles.mainSection}>
        <div style={styles.sectionsContainer}>
          {sections.map((sec, i) => {
            // 1ª y 3ª sección: izquierda; 2ª y 4ª: derecha
            const Component = [
              SectionBodyLeft,
              SectionBodyRight,
              SectionBodyLeft,
              SectionBodyRight,
            ][i];
            return (
              <Component
                key={i}
                icon={sec.icon}
                title={sec.title}
                imageSrc={sec.imageSrc}
                texts={sec.texts}
              />
            );
          })}
        </div>

        {/* Economic Impact Stats Section */}
        <EconomicImpactStats stats={impactStats} language={language} />

        {/* FAQs Section */}
        <FAQ items={faqs[language]} language={language} />
      </main>

      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}
